'use client';



import { useNavigate } from "../../hooks/useNavigate";
import { useState } from "react";
import { CiLocationOn, CiCalendar } from "react-icons/ci";
import { IoClose } from "react-icons/io5";
import { FaSearchengin } from "react-icons/fa6";
import { useGetJob } from "../../api/careerapi/career";
import { GoArrowUpRight } from "react-icons/go";
import toast from "react-hot-toast";

export default function Jobs() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");

  // Fetch all jobs
  const { data: allJobsData, isLoading: isLoadingAll } = useGetJob("", "");
  const allJobs = allJobsData?.data?.careerData || [];

  // Extract unique job roles as categories
  // Predefined job categories
  const predefinedCategories = [
    { id: 1, label: "All" },
    { id: 2, label: "Web Development" },
    // { id: 3, label: "Game Development" },
    { id: 4, label: "UI/UX Design" },
    { id: 5, label: "Software Development" },
    { id: 6, label: "Graphic Design" },
    { id: 7, label: "Digital Marketing" },
  ];

  // Fetch jobs based on selected category

  // Fetch filtered jobs
  const { data, isLoading, error } = useGetJob(
    selectedCategory === "All" ? "" : selectedCategory,
    search
  );
  let jobs = data?.data?.careerData || [];

  // Remove jobs with status! === "1"
  jobs = jobs.filter((job) => job.status == "1");
  const employmentTypeMap = {
    1: "Full-Time",
    2: "Part-Time",
    3: "Contract",
    4: "Internship",
  };
  const handleNavigation = (e, jobId) => {
    e.stopPropagation(); // Prevent event bubbling
    navigate(`/careers/jobs/${jobId}`);
  };
  const handleApplyClick = (e, job) => {
    e.stopPropagation();
    const jobStatus = Number(job.status);
    if (jobStatus === 1) {
      navigate(`/careers/jobs/${job.id}`);
    } else if (jobStatus === 2) {
      toast.success("We will inform you when a job opening is available.");
    }
  };
  return (
    <div className="min-h-screen px-6 py-10 ">
      {/* Header */}
      <h1 className="text-color-1 text-center text-2xl lg:text-4xl font-medium my-5 md:my-8">
        Do You Have What It Takes To Work At Centera ?
      </h1>

      {/* Search & Category Filter */}
      <div className="flex flex-col justify-between items-center gap-5 mb-10">
        {/* Search Input */}
        <div className="w-72 md:w-80">
          <SearchInput search={search} setSearch={setSearch} />
        </div>

        {/* Categories Filter (Job Roles) */}
        {/* Categories Filter (Predefined Job Roles) */}
        <div className="flex flex-wrap gap-3">
          {/* {predefinedCategories.map((category) => (
        <button
              key={category.id}
              className={`rounded-full `}
              onClick={() => setSelectedCategory(category.label)}
            >
              <div
                className={`relative overflow-hidden flex justify-center items-center gap-2 py-1.5 px-4 rounded-full border text-sm text-center font-medium transition-all duration-300 ${
                  selectedCategory === category.label
                    ? " border-color-97 text-color-100"
                    : "border-color-97 hover:border-color-50 text-color-2 hover:text-color-1"
                }`}
              >
                <div
                  className={`absolute h-full w-full bg-[linear-gradient(180deg,_var(--accent-light),_var(--accent-dark))] transition-all duration-500 ${
                    selectedCategory === category.label
                      ? " opacity-100"
                      : "opacity-0"
                  } `}
                ></div>
                <p className="z-10">{category.label}</p>
              </div>
            </button>
             ))} */}
          {predefinedCategories.map((category) => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.label)}
              className={`relative overflow-hidden flex justify-center items-center gap-2 py-1.5 px-4 rounded-full border text-sm text-center font-medium transition-all duration-300
      ${
        selectedCategory === category.label
          ? "border-color-97 text-color-100"
          : "border-color-97 hover:border-color-50 text-color-2 hover:text-color-1"
      }`}
            >
              <div
                className={`absolute h-full w-full bg-[linear-gradient(180deg,_var(--accent-light),_var(--accent-dark))] transition-all duration-500 ${
                  selectedCategory === category.label
                    ? "opacity-100"
                    : "opacity-0"
                }`}
              ></div>
              <span className="z-10">{category.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Job Listings */}
      <div className="space-y-6">
        {isLoading || isLoadingAll ? (
          <Shimmer />
        ) : error ? (
          <>
            {setTimeout(() => navigate("/careers"), 100)}{" "}
            {/* Redirect after 2s */}
          </>
        ) : jobs.length > 0 ? (
          jobs.map((job) =>
            Number(job.status) !== 3 ? (
              <div
                key={job.id}
                onClick={(e) => handleNavigation(e, job.id)}
                className="relative max-w-2xl mx-auto px-[1px] py-[1px] rounded-lg shadow-lg border border-gray-700 overflow-hidden group cursor-pointer"
              >
                {/* Subtle Border Glow Effect */}
                <div className="absolute inset-0 rounded-xl bg-[linear-gradient(155deg,var(--accent-light),#555_60%)] transition-transform duration-700 group-hover:rotate-180 blur-3xl scale-150"></div>

                {/* Card Content */}
                <div className="relative bg-[var(--secondary-bg)] backdrop-blur-md p-8 rounded-lg group/nested transition-all duration-300">
                  <div className="flex justify-between items-center">
                    <h2 className="text-base font-semibold text-white">
                      {job.title}
                    </h2>
                    <button
                      onClick={(e) => handleApplyClick(e, job)}
                      className="text-[var(--accent-light)] font-medium flex items-center gap-1 text-sm "
                    >
                      Apply
                      <div className="text-color-1 text-base transition-all duration-300 ml-auto group-hover/nested:scale-125 opacity-70 group-hover/nested:opacity-100 mr-3 group-hover/nested:mr-2 group-hover/nested:animate-pulse group-hover/nested:text-[var(--accent-light)]">
                        <GoArrowUpRight className="w-5 h-5" />
                      </div>
                    </button>
                  </div>
                  <p className="mt-2 text-gray-400 text-xs md:text-sm">
                    <div className="text-color-2 mb-4">
                      {job.skills?.slice(0, 2).map((skill, index) => (
                        <p key={index} className="mb-1">
                          {skill}
                        </p>
                      ))}
                    </div>
                  </p>

                  {/* Tags Section */}
                  <div className="mt-3 flex flex-wrap gap-2">
                    <span className="flex items-center gap-1 px-3 py-1 border border-gray-700 rounded-full text-xs text-gray-300">
                      <CiLocationOn className="w-4 h-4 text-[var(--accent-light)]" />
                      {job.location}
                    </span>
                    <span className="flex items-center gap-1 px-3 py-1 border border-gray-700 rounded-full text-xs text-gray-300">
                      <CiCalendar className="w-4 h-4 text-[var(--accent-light)]" />
                      {employmentTypeMap[job.employment_type] ||
                        "Not Specified"}
                    </span>
                  </div>
                </div>
              </div>
            ) : null
          )
        ) : (
          <p className="text-gray-400 text-center">
            No jobs available for{" "}
            {selectedCategory !== "All" ? `"${selectedCategory}"` : "this role"}
            {search ? ` matching "${search}"` : ""}.
          </p>
        )}
      </div>
    </div>
  );
}

// Search Input Component
function SearchInput({ search, setSearch }) {
  return (
    <div className="relative w-full">
      <FaSearchengin className="absolute left-3 top-1/2 transform -translate-y-1/2 text-color-2" />
      <input
        type="text"
        placeholder="Search jobs..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="text-sm w-full bg-color-98 text-color-1 border rounded-lg px-10 py-2 transition duration-300 focus:outline-none focus:border-[var(--accent-dark)] hover:border-[var(--accent-dark)] border-color-97"
      />
      {search && (
        <button
          onClick={() => setSearch("")}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-color-2 hover:text-color-1 transition"
        >
          <IoClose className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}

// Shimmer Effect Component
function Shimmer() {
  return (
    <div className="flex flex-col gap-6 max-w-3xl mx-auto p-6">
      {[1, 2].map((_, index) => (
        <div
          key={index}
          className="w-full p-6 rounded-lg shadow-lg border border-gray-700 animate-pulse"
        >
          <div className="h-6 w-40 bg-gray-700 rounded"></div>
          <div className="h-4 w-full bg-gray-700 rounded my-2"></div>
          <div className="h-4 w-3/4 bg-gray-700 rounded"></div>
          <div className="mt-4 flex gap-3">
            <span className="h-5 w-24 bg-gray-700 rounded"></span>
            <span className="h-5 w-24 bg-gray-700 rounded"></span>
          </div>
        </div>
      ))}
    </div>
  );
}
